import { render } from "./DynamicsMessages.vue?vue&type=template&id=710c5503"
import script from "./DynamicsMessages.vue?vue&type=script&lang=js"
export * from "./DynamicsMessages.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__